module.exports = __webpack_public_path__ + "img/fashion_59.a2c6ef56.jpg";